module.exports = __webpack_public_path__ + "media/bg-video.0bc68190.mp4";